import { KTSVG } from '_metronic/helpers';
import NumericComponent from 'app/components/FormComponents/NumericComponent';
import SelectComponent from 'app/components/FormComponents/SelectComponent';
import TextComponent from 'app/components/FormComponents/TextComponent/TextComponent';
import TableComponent from 'app/components/TableComponent';
import * as Yup from 'yup';
import { getTypeAddress } from 'app/service/catalog/Catalogs';
import { SelectOption } from 'app/types/commons';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap-v5';
import { getLocationByCp, getPersonAddress, postPersonAddress } from 'app/service/address/address';
import { Address } from 'app/types/address';
import { toast } from 'react-toastify';
import { Collaborator } from 'app/types/collaborator';

type Props = {
    collaborator?: Collaborator;
};

const heads = [
    {
        code: 'typeAddress',
        label: 'Tipo de Dirección',
    },
    {
        code: 'codePostal',
        label: 'Código Postal',
    },
    {
        code: 'country',
        label: 'País',
    },
    {
        code: 'entity',
        label: 'Estado',
    },
    {
        code: 'locality',
        label: 'Ciudad',
    },
    {
        code: 'colony',
        label: 'Colonia',
    },
    {
        code: 'street',
        label: 'Calle',
    },
    {
        code: 'externalNumber',
        label: 'Número exterior',
    },
    {
        code: 'internalNumber',
        label: 'Número interior',
    },
];

const validationSchema = Yup.object({
    // type_address: Yup.object({
    //     value: Yup.number().nullable(false).required("Este campo es requerido"),
    //     label: Yup.string().nullable(false).required("Este campo es requerido"),
    // })
    //     .nullable(false)
    //     .required('Este campo es requerido'),
    type_address: Yup.object({
        value: Yup.number(),
        label: Yup.string(),
    })
        .nullable()
        .required('El tipo de direccion es requerido'),
    cp: Yup.string().required('Este campo es requerido'),
    colony: Yup.object({
        value: Yup.number(),
        label: Yup.string(),
    })
        .nullable()
        .required('Este campo es requerido'),
    street: Yup.string().required('Este campo es requerido'),
    exterior: Yup.string().required('Este campo es requerido').matches(/^[a-zA-Z0-9\s]+$/, "Sólo caracteres comunes")
        .max(10, "Máximo 10 caracteres"),
    interno: Yup.string().notRequired().matches(/^[a-zA-Z0-9\s]+$/, "Sólo caracteres comunes").max(10, "Máximo 10 caracteres")
});

type FormValues = {
    type_address: SelectOption | null;
    cp: string;
    country: SelectOption | null;
    state: SelectOption | null;
    city: SelectOption | null;
    colony: SelectOption | null;
    interno: string;
    exterior: string;
    street: string;
};

const initialValues: FormValues = {
    type_address: null,
    cp: '',
    country: null,
    state: null,
    city: null,
    colony: null,
    interno: '',
    exterior: '',
    street: '',
};

const Direcciones: React.FC<Props> = ({ collaborator }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [typeAddresses, setTypeAddresses] = useState<SelectOption[]>([]);
    const [rows, setRows] = useState<Address[]>([]);
    const [colonies, setColonies] = useState<SelectOption[]>([]);
    const [country, setCountry] = useState<SelectOption>({ value: 0, label: '' });
    const [entity, setEntity] = useState<SelectOption>({ value: 0, label: '' });
    const [locality, setLocality] = useState<SelectOption>({ value: 0, label: '' });
    const formData = useFormik<FormValues>({
        initialValues,
        validationSchema,
        onSubmit: async (values, { setSubmitting }) => {
            setLoading(true);
            try {
                await postPersonAddress({
                    personId: Number(collaborator!.personId!),
                    countryId: country.value,
                    entityId: entity.value,
                    localityId: locality.value,
                    codePostal: values.cp,
                    street: values.street,
                    typeAddressId: values.type_address?.value,
                    externalNumber: values.exterior,
                    internalNumber: values.interno,
                    colonyId: values.colony?.value,
                });
                formData.resetForm();
                const addressRes = await getPersonAddress(collaborator!.personId!);
                setRows(addressRes);
                const message = 'Se agregó la dirección con éxito';
                toast.success(message, {
                    position: 'top-right',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: 'light',
                });
                handleClose();
            } catch (error: any) {
                console.error('Error en enviar', error)
                const defaultError = 'Verifique que la información es correcta';
                toast.error(defaultError, {
                    position: 'top-right',
                    autoClose: 4000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: 'light',
                });
            } finally {
                setLoading(false);
                setSubmitting(false);
            }
        },
    });
    const handleClose = () => {
        formData.resetForm();
        setCountry({ value: 0, label: '' });
        setEntity({ value: 0, label: '' });
        setLocality({ value: 0, label: '' });
        setColonies([]);
        setShow(false);
    };
    const addRow = () => {
        setShow(true);
    };
    const fillDataAsync = async () => {
        try {
            const typeAddressRes = await getTypeAddress().catch((err) => {
                console.error('Error en carga de catalogos', err);
            });
            const addressRes = await getPersonAddress(collaborator!.personId!).catch((err) => {
                console.error('Error en carga de catalogos', err);
            });
            if (typeAddressRes)
                setTypeAddresses(typeAddressRes.records.map((item) => ({
                    value: item.id,
                    label: item.description,
                })));
            if (addressRes)
                setRows(addressRes);
        } catch (error) {
            console.error('Error en carga de catalogos', error)
        }
    };
    const FillLocation = async () => {
        try {
            const data = await getLocationByCp(formData.values.cp);
            setColonies(data.colonies.map((item) => ({
                label: item.name,
                value: item.id,
            })));
            setCountry({
                value: data.countryId,
                label: data.country,
            })
            setEntity({
                value: data.entityId,
                label: data.entity,
            });
            setLocality({
                value: data.id,
                label: data.description,
            })
        } catch (error: any) {
            const defaultError = 'No se encontró el código postal';
            toast.error((error.response?.status === 404
                ? defaultError
                : error.message), {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'light',
            });
        }
    };
    useEffect(() => {
        if (collaborator)
            fillDataAsync();
    }, [collaborator]);
    useEffect(() => {
        if (formData.values.cp.length === 5) {
            FillLocation();
        }
    }, [formData.values.cp]);
    return (
        <div>
            <TableComponent heads={heads} rows={rows} />
            <div className="d-flex align-items-center">
                <button
                    className="btn btn-light-primary btn-sm mb-10"
                    onClick={addRow}
                    disabled={!collaborator?.personId}
                >
                    <KTSVG
                        path="/media/icons/duotune/arrows/arr075.svg"
                        className="svg-icon-5"
                    />
                    Agregar Dirección
                </button>
            </div>
            <Modal
                id="kt_modal_create"
                tabIndex={-1}
                aria-hidden="true"
                dialogClassName="modal-dialog mw-800px"
                show={show}
                onHide={handleClose}
            >
                <div className="modal-content">
                    <div className="modal-header">
                        <h2 className="text-muted">{"Dirección"}</h2>
                        <div
                            className="btn btn-sm btn-icon btn-active-color-primary"
                            onClick={handleClose}
                        >
                            <KTSVG
                                className="svg-icon-2"
                                path="/media/icons/duotune/arrows/arr061.svg"
                            />
                        </div>
                    </div>
                    <div className="modal-body mx-5 padding-top-00">
                        <form
                            id="kt_modal_generic_form"
                            className="form"
                            action="#"
                            onSubmit={formData.handleSubmit}
                        >
                            <div className="d-flex flex-column flex-xl-row flex-row-fluid mt-5">
                                <div className="w-100 d-flex">
                                    <div className="w-100 pe-5">
                                        <div className='container'>
                                            <div className="row g-9 mb-7">
                                                <div className="col">
                                                    <SelectComponent
                                                        name='type_address'
                                                        label='Tipo Dirección'
                                                        formData={formData}
                                                        options={typeAddresses}
                                                        required
                                                        // display={'-1'}
                                                    />
                                                </div>
                                                <div className="col">
                                                    <NumericComponent
                                                        name='cp'
                                                        label='Código Postal'
                                                        min={0}
                                                        maxLength={5}
                                                        formData={formData}
                                                        decimalScale={0}
                                                        required
                                                        display={'-1'}
                                                    />
                                                    {formData.touched.cp && formData.errors.cp && (
                                                        <div className="fv-plugins-message-container text-danger w-100">
                                                            <span role="alert">{formData.errors.cp}</span>
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="col col-md-4 fv-row fv-plugins-icon-container">
                                                    <label>País</label>
                                                    <input
                                                        type="text"
                                                        className={`form-control`}
                                                        value={country?.label}
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div className="row g-9 mb-7">
                                                <div className="col">
                                                    <label>Estado</label>
                                                    <input
                                                        type="text"
                                                        className={`form-control`}
                                                        value={entity?.label}
                                                        disabled
                                                    />
                                                </div>
                                                <div className="col">
                                                    <label>Ciudad</label>
                                                    <input
                                                        type="text"
                                                        className={`form-control`}
                                                        value={locality?.label}
                                                        disabled
                                                    />
                                                </div>
                                                <div className="col">
                                                    <SelectComponent
                                                        name='colony'
                                                        label='Colonia'
                                                        formData={formData}
                                                        options={colonies}
                                                        required
                                                        display={'-1'}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row g-9 mb-7">
                                                <div className="col">
                                                    <TextComponent
                                                        name='street'
                                                        label='Calle'
                                                        formData={formData}
                                                        required
                                                        display={'-1'}
                                                    />
                                                    {formData.touched.street && formData.errors.street && (
                                                        <div className="fv-plugins-message-container text-danger w-100">
                                                            <span role="alert">{formData.errors.street}</span>
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="col">
                                                    <TextComponent
                                                        name='exterior'
                                                        label='Número Exterior'
                                                        formData={formData}
                                                        required
                                                        max={11}
                                                        display={'-1'}
                                                    />
                                                    {formData.touched.exterior && formData.errors.exterior && (
                                                        <div className="fv-plugins-message-container text-danger w-100">
                                                            <span role="alert">{formData.errors.exterior}</span>
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="col">
                                                    <TextComponent
                                                        name='interno'
                                                        label='Número Interno'
                                                        formData={formData}
                                                        max={11}
                                                        display={'-1'}
                                                    />
                                                    {formData.touched.interno && formData.errors.interno && (
                                                        <div className="fv-plugins-message-container text-danger w-100">
                                                            <span role="alert">{formData.errors.interno}</span>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="d-flex justify-content-end mt-10">
                                <button
                                    type="reset"
                                    className="btn btn-light me-3"
                                    data-kt-users-modal-action="cancel"
                                    onClick={handleClose}
                                >
                                    Cancelar
                                </button>
                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                    data-kt-users-modal-action="submit"
                                    disabled={loading || !colonies.length}
                                >
                                    {!loading && <span className="indicator-label">Guardar</span>}
                                    {loading && (
                                        <span
                                            className="indicator-progress"
                                            style={{ display: "block" }}
                                        >
                                            Espere por favor...
                                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                        </span>
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default Direcciones;